module.exports = __webpack_public_path__ + "img/abo11.d6a8dfd8.jpg";